//Runs once, then stops at 33 seconds
jQuery(document).ready(function($){
    var $video = $("#hero-video");
    var video = $video.get(0);
 
    var stopAt = 33;
 
    $video.on("timeupdate.heroStop", function () {
        if (video.currentTime >= stopAt) {
            $video.off("timeupdate.heroStop"); // stop before seeking to avoid re-triggering loop
            video.pause();
            video.currentTime = stopAt;
        }
    });
});